import MundialRequestTask from "./MundialRequestTask";

export class RosterTask  extends MundialRequestTask {
  teamId: string;

  constructor(teamId: string) {
    super();
    this.teamId = teamId;
  }

  getUrl() {
    const baseUrl = this.getBaseUrl(); 
    return `${baseUrl}/leagues/${this.leagueId}/teams/${this.teamId}/roster`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/RosterTask.ts